import { cx } from '@7f-ui'
import { Skeleton } from '@7f-ui/components/skeleton/skeleton'

export function AccommodationRoomSkeleton() {
  return (
    <div className="grid">
      <div className="grid grid-cols-6 gap-4 sm:grid-cols-12 sm:gap-8">
        <Skeleton
          className={cx(
            'aspect-3/2 h-auto w-full object-cover sm:aspect-4/3',
            'col-span-6 sm:col-span-5 md:col-span-6'
          )}
        />

        <div className="col-span-6 sm:col-span-7 sm:col-start-6 md:col-span-6 md:col-start-7">
          <Skeleton className="mb-4 h-7 w-8/12 sm:mb-7 lg:h-9" />
          <div className="grid grid-cols-3">
            <Skeleton className="mb-7 h-6 w-9/12 sm:mb-10" />
            <Skeleton className="mb-7 h-6 w-9/12 sm:mb-10" />
            <Skeleton className="mb-7 h-6 w-9/12 sm:mb-10" />

            <Skeleton className="mb-7 h-6 w-9/12 sm:mb-10" />
            <Skeleton className="mb-7 h-6 w-9/12 sm:mb-10" />
            <Skeleton className="mb-7 h-6 w-9/12 sm:mb-10" />
          </div>

          <Skeleton className="mb-5 h-4 w-4/12 sm:mb-16" />

          <Skeleton className="mb-2 h-7 w-1/4" />
          <Skeleton className="mb-10 h-4 w-2/3" />

          <Skeleton className="h-12 w-2/4" />
        </div>
      </div>
    </div>
  )
}
